import { createContext, useContext, useState, useCallback, useRef } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const show = useCallback((message) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(message);
    timerRef.current = setTimeout(() => setToast(null), 2000);
  }, []);

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: 100,
            left: "50%",
            transform: "translateX(-50%)",
            background: "#143D2E",
            color: "#fff",
            borderRadius: 12,
            padding: "10px 20px",
            zIndex: 9999,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: "'Outfit', sans-serif",
            pointerEvents: "none",
            whiteSpace: "nowrap",
            animation: "toastFadeInOut 2s ease forwards",
          }}
        >
          {toast}
        </div>
      )}
      <style>{`
        @keyframes toastFadeInOut {
          0%   { opacity: 0; }
          15%  { opacity: 1; }
          75%  { opacity: 1; }
          100% { opacity: 0; }
        }
      `}</style>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used inside ToastProvider");
  return ctx;
}
